import { PaletteOptions } from "@mui/material";
import { InternalThemeConfig } from "./config";

const getOverride = ({ palette }: InternalThemeConfig): PaletteOptions => {
  return {
    primary: {
      main: palette.primary,
      light: palette.lightPrimary,
    },
    secondary: {
      main: palette.secondary,
      light: palette.lightSecondary,
    },
    error: {
      main: palette.danger,
      light: palette.dangerLight,
    },

    text: {
      disabled: palette.textDisabled,
      primary: palette.textPrimary,
      secondary: palette.textSecondary,
    },
  };
};

export default getOverride;
